import { isDouyinMiniProgramEnv, isLfMiniProgramEnv } from "../utils/miniProgramEnv";
import type { MiniappPayChannelConfig } from "./MiniappPayChannelApi";

export type MiniappOsKind = "android" | "ios" | "other";

/** 从 UA 粗判安卓 / 苹果（web-view 内可用） */
export function detectMiniappOsKind(): MiniappOsKind {
  if (typeof navigator === "undefined") {
    return "other";
  }
  const ua = (navigator.userAgent || "").toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    return "ios";
  }
  if (/android/.test(ua)) {
    return "android";
  }
  return "other";
}

/**
 * 当前小程序宿主 + 系统下，是否允许走原生支付。
 * 非小程序环境返回 false（应走企微引导）。
 * other 系统默认允许（与缺省开通道一致）。
 */
export function isNativeMiniappPayEnabled(
  config: MiniappPayChannelConfig,
  opts?: { os?: MiniappOsKind; douyin?: boolean }
): boolean {
  if (!isLfMiniProgramEnv()) {
    return false;
  }
  const os = opts?.os ?? detectMiniappOsKind();
  const douyin = opts?.douyin ?? isDouyinMiniProgramEnv();
  if (os === "android") {
    return douyin ? config.douyinAndroidPayEnabled : config.wechatAndroidPayEnabled;
  }
  if (os === "ios") {
    return douyin ? config.douyinIosPayEnabled : config.wechatIosPayEnabled;
  }
  return true;
}
